import { render, staticRenderFns } from "./MesaDelegacionesTramiteNewOrEdit.vue?vue&type=template&id=13ff46f6&"
import script from "./MesaDelegacionesTramiteNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./MesaDelegacionesTramiteNewOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports